/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SquareMousePointer = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" }],
    ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z" }]
  ]
];

export { SquareMousePointer as default };
//# sourceMappingURL=square-mouse-pointer.js.map
